import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Case from '../views/Case.vue'
import Range from '../views/Range.vue'
import Honor from '../views/Honor.vue'
import News from '../views/News.vue'
import Contact from '../views/Contact.vue'
import NewsDetails from '../views/NewsDetails.vue'

Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/about',
		name: 'About',
		component: About
	},
	{
		path: '/case',
		name: 'Case',
		component: Case
	},
	{
		path: '/range',
		name: 'Range',
		component: Range
	},
	{
		path: '/honor',
		name: 'Honor',
		component: Honor
	},
	{
		path: '/news',
		name: 'News',
		component: News
	},
	{
		path: '/contact',
		name: 'Contact',
		component: Contact
	},
	{
		path: '/news/details:item',
		name: 'NewsDetails',
		component: NewsDetails
	}
]

const router = new VueRouter({
	// mode: 'history',
	routes,
	scrollBehavior() { //禁止浏览器前进后退，另一部分在main.js中
		history.pushState(null,null,document.URL);
	}
})

export default router
